import { Button } from '@avanta/shared/components/ui/Button';
import { Card } from '@avanta/shared/components/ui/Card';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import Image from 'assets/home/barometer.webp';
import { ROUTES } from 'constants/routes';
import { BAROMETER_RESULT_AREAS } from '../../types';
import { WellBeingArea } from '../WellBeingArea';

export const SurveyBarometer = (): React.ReactElement => {
  const navigate = useNavigate();
  const { t } = useTranslation(LOCIZE_NS.HOME);

  const handleStart = (): void => {
    navigate(ROUTES.WELL_BEING_BAROMETER);
  };

  return (
    <Card className="min-w-0 border-0 bg-plum-100 p-6 shadow-none am-2xl:h-75">
      <div className="flex min-w-0 flex-col gap-4 am-2xl:flex-row am-2xl:items-start am-2xl:justify-between">
        <div className="flex w-full min-w-0 items-start gap-8 am-2xl:flex-1">
          <img
            src={Image}
            alt={t('Pae.SurveyBarometer.title')}
            className="hidden h-63 w-50 shrink-0 rounded-tl-xl rounded-br-xl object-cover am-2xl:block"
          />
          <div className="flex w-full min-w-0 flex-col gap-2">
            <p className="text-gray-400 text-xs leading-5 am-2xl:mt-2 am-2xl:text-sm">
              {t('Pae.SurveyBarometer.heading')}
            </p>
            <h3 className="mt-2 text-denim-800 leading-5 font-medium am-2xl:mt-5 am-2xl:text-2xl am-2xl:leading-7">
              {t('Pae.SurveyBarometer.title')}
            </h3>
            <p className="text-base leading-5 text-denim-500 am-2xl:max-w-140">
              {t('Pae.SurveyBarometer.body')}
            </p>
            <Button
              size="lg"
              variant="secondary"
              className="mt-4 w-full am-2xl:mt-12 am-2xl:w-fit"
              onClick={handleStart}
            >
              {t('Pae.SurveyBarometer.cta')}
            </Button>
            <p className="min-w-0 max-w-full text-pretty text-center text-gray-400 text-xs leading-5 am-2xl:text-left am-2xl:text-sm">
              {t('Pae.SurveyBarometer.timeHint')}
            </p>
          </div>
        </div>
        <div className="hidden w-66 shrink-0 flex-col gap-4 am-2xl:flex">
          {BAROMETER_RESULT_AREAS.map(area => (
            <WellBeingArea key={area} area={area} />
          ))}
        </div>
      </div>
    </Card>
  );
};
